import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Storage } from '@ionic/storage'

import { NUBE_AWS, URL_SERVICIOS_AWS, URL_SERVICIOS_LOCALES, URL_SERVICIOS_LOCALES_IMPRESORA } from '../../config/url.servicio'

@Injectable()
export class ComandasProvider {
  token:string
  urlPrintService:string

  constructor(public http: Http, private storage:Storage) {
      this.storage.get('token').then((val) => {
          this.token = val
      });

      this.storage.get('urlPrint').then((val) => {
          this.urlPrintService = val
      });
  }

  guardarComandas (data,codigo){
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + this.token
      })

      let options = new RequestOptions({
          headers: headers
      })
      const datos = {
          "datos": JSON.stringify(data),
          "codigo": codigo
          }

      return this.http
          .post(`${url}/proceso/almacenarComandas`, datos, options)
  }

  guardarComandasGrupos (data,codigo){
    let url = URL_SERVICIOS_LOCALES
    let headers = new Headers({
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + this.token
    })

    let options = new RequestOptions({
        headers: headers
    })
    const datos = {
        "datos": JSON.stringify(data),
        "codigo": codigo
        }

    return this.http
        .post(`${url}/proceso/almacenarComandasGrupos`, datos, options)
}

  buscarComandas(codigo:any) {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=buscarComandas&mesa=${codigo}`)
      .map((data) => data.json())
    }

    buscarComandasSinFacturar() {
        let url = URL_SERVICIOS_LOCALES
        return this.http.get(`${url}/proceso/buscarComandasSinFacturar`)
        .map((data) => data.json())
      }


      buscarComandasSinFacturarPorCompania(companiasId:any) {
        if(NUBE_AWS) {
          let url_servicio = URL_SERVICIOS_AWS;
          let data = {
            name: 'buscarSalonSinFacturarPorCompania',
            parameters : {companiasId: companiasId}
          }
          let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
          let options = new RequestOptions({ headers: headers }) // Create a request option
          return this.http.post(`${url_servicio}/procedure`, data, options);
        } else {
        let url = URL_SERVICIOS_LOCALES
        return this.http.get(`${url}/proceso/buscarComandasSinFacturarPorCompania?companiasId=${companiasId}`)
        .map((data) => data.json())
        }
      }

      buscarSalonSinFacturarPorCompania(companiasId:any, centroDeCostosGestionId:any) {
        if(NUBE_AWS) {
          let url_servicio = URL_SERVICIOS_AWS;
          let data = {
            name: 'buscarComandasSinFacturarPorCompania',
            parameters : {companiasId: companiasId, centroDeCostosGestionId:centroDeCostosGestionId}
          }
          let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
          let options = new RequestOptions({ headers: headers }) // Create a request option
          return this.http.post(`${url_servicio}/procedure`, data, options);
        } else {
        let url = URL_SERVICIOS_LOCALES
        return this.http.get(`${url}/proceso/buscarComandasSinFacturarPorCompania?companiasId=${companiasId}`)
        .map((data) => data.json())
        }
      }

      buscarComandasGruposPorCompania(clientesId:any,companiasId:any) {
        let url = URL_SERVICIOS_LOCALES
        return this.http.get(`${url}/proceso/buscarComandasGruposPorCompania?clientesId=${clientesId}&companiasId=${companiasId}`)
        .map((data) => data.json())
      }


      GuardarDomiciliosAppComandasVacio(companiasId: any,usuariosId: any,clientesId: any,descripcion:any) {
        let url = URL_SERVICIOS_LOCALES
        return this.http.get(`${url}/proceso/GuardarDomiciliosAppComandasVacio?companiasId=${companiasId}&usuariosId=${usuariosId}&clientesId=${clientesId}&descripcion=${descripcion}`)
        .map((data) => data.json())
      }
    buscarComandasDomicilios() {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/query?name=buscarComandasDomicilios`)
      .map((data) => data.json())
    }

    actualizarComandas(comanda: any) {
      if(NUBE_AWS) {
        let url_servicio = URL_SERVICIOS_AWS;
        let values = {
          name: "dataDynamicCrud",
          parameters : {...comanda, nombreTabla: "comandas"}
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option
        return this.http.post(`${url_servicio}/procedure`, values, options);
      } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })
      return this.http.put(`${url}/query`, comanda, options)
    }
  }
    genearNotificacionComandas(titulo,mensaje) {
      if(NUBE_AWS) {
        let url_servicio = URL_SERVICIOS_AWS;
        let values = {
          name: "notificacion",
          parameters : {titulo:titulo,mensaje:mensaje}
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option
        return this.http.post(`${url_servicio}/procedure`, values, options);
      } else {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/notificacion?titulo=${titulo}&mensaje=${mensaje}`)
          .map((data) => data.json())
  }
}

  cancelarComandas(item: any) {
    if(NUBE_AWS) {
      let url_servicio = URL_SERVICIOS_AWS;
      let values = {
        name: "cancelarComandas",
        parameters : {codigo:item.codigo}
      }
      let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
      let options = new RequestOptions({ headers: headers }) // Create a request option
      return this.http.post(`${url_servicio}/procedure`, values, options);
    } else {
      let url = URL_SERVICIOS_LOCALES
      let headers = new Headers({
        'Content-Type': 'application/json'
      })
      let options = new RequestOptions({
        headers: headers
      })
      return this.http.get(`${url}/query?name=cancelarComandas&codigo=${item.codigo}`, options)
    }
  }
    eliminarComandas(item: any) {
      if(NUBE_AWS) {
        let url_servicio = URL_SERVICIOS_AWS;
        let data = {
          name: "eliminarComandas",
          parameters : {codigo: item[0].codigo}
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option
        return this.http.post(`${url_servicio}/procedure`, data, options);
      } else {
        let url = URL_SERVICIOS_LOCALES
        let headers = new Headers({
          'Content-Type': 'application/json'
        })
        let options = new RequestOptions({
          headers: headers
        })
        return this.http.get(`${url}/query?name=eliminarComandas&codigo=${item[0].codigo}`, options)
      }
    }


    actualizarGestionComandasSalon(item: any,companiasId:any,tipo:any) {
      if(NUBE_AWS) {
        let url_servicio = URL_SERVICIOS_AWS;
        let data = {
          name: "actualizarGestionComandasSalon",
          parameters : {codigo: item[0].codigo,companiasId:companiasId,tipo:tipo }
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option
        return this.http.post(`${url_servicio}/procedure`, data, options);
      } else {
        let url = URL_SERVICIOS_LOCALES
        let headers = new Headers({
          'Content-Type': 'application/json'
        })
        let options = new RequestOptions({
          headers: headers
        })
        return this.http.get(`${url}/query?name=eliminarComandas&codigo=${item[0].codigo}`, options)
      }
    }

    actualizarGestionComandasCocina(item: any,companiasId:any,tipo:any) {
      if(NUBE_AWS) {
        let url_servicio = URL_SERVICIOS_AWS;
        let data = {
          name: "actualizarGestionComandasCocina",
          parameters : {codigo: item[0].codigo,companiasId:companiasId,tipo:tipo }
        }
        let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
        let options = new RequestOptions({ headers: headers }) // Create a request option
        return this.http.post(`${url_servicio}/procedure`, data, options);
      } else {
        let url = URL_SERVICIOS_LOCALES
        let headers = new Headers({
          'Content-Type': 'application/json'
        })
        let options = new RequestOptions({
          headers: headers
        })
        return this.http.get(`${url}/query?name=eliminarComandas&codigo=${item[0].codigo}`, options)
      }
    }




      imprimirComandasMesas (codigo, companiasId){
        if(NUBE_AWS) {
          let url_servicio = URL_SERVICIOS_AWS;
          let data = {
            name: "imprimirComandasMesas",
            parameters : {elRecibo: codigo, companiasId:JSON.stringify(companiasId)}
          }
          let headers = new Headers({ 'Content-Type': 'application/json' }) // ... Set content type to JSON
          let options = new RequestOptions({ headers: headers }) // Create a request option
          return this.http.post(`${url_servicio}/procedure`, data, options);
        } else {
        let url = URL_SERVICIOS_LOCALES
        let headers = new Headers({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this.token
        })

        let options = new RequestOptions({
            headers: headers
        })

        const datos = {
            "elRecibo": codigo,
            "companiasId": JSON.stringify(companiasId)
        }

        return this.http
            .post(`${url}/proceso/imprimirComandasMesas`, datos, options)
      }
    }

}



// WEBPACK FOOTER //
// ./src/providers/comandas/comandas.ts